import { IconButton } from '@fukuri-admins/ui/common/IconButton';
import { CrossIcon, FileIcon } from '@fukuri-admins/ui/common/Icons';
import React from 'react';
import styles from './styles.module.scss';

// ファイルサイズを人間が読みやすい形式にフォーマット
const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
};

type Props = {
  name: string;
  /** ファイルサイズ（バイト）。未指定の場合はサイズ表示を省略する */
  sizeBytes?: number;
  /** trueのとき削除ボタンを非活性にする。アップロード中や全体disabled時に使用する */
  disabled?: boolean;
  onRemove: () => void;
};

export const FileItem: React.FC<Props> = ({ name, sizeBytes, disabled = false, onRemove }) => (
  <div className={styles.row}>
    <div className={styles.fileInfo}>
      {/* ファイルアイコン */}
      <FileIcon size='xs' className={styles.icon} />
      {/* ファイル名 */}
      <span className={styles.name}>{name}</span>
      {/* ファイルサイズ（未指定の場合は非表示） */}
      {sizeBytes !== undefined && <span className={styles.size}>{formatFileSize(sizeBytes)}</span>}
    </div>
    {/* 削除ボタン（ghost スタイル） */}
    <IconButton
      variant='ghost'
      size='sm'
      icon={<CrossIcon size='xs' />}
      aria-label={`${name}を削除`}
      onClick={onRemove}
      disabled={disabled}
    />
  </div>
);
